import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as VictoryImage } from '../../resources/images/victory.svg';
import { FullScreenPageNoButton } from '../FullScreenButtonPage';
import { makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { ACCOUNT_SETUP_COMPLETE_MESSAGE_BODY } from '../../resources/messages.json';
import { COLOR_WHITE } from '../utilities/Material';

const useStyles = makeStyles(theme => ({
    marginTop: {
        marginTop: theme.spacing(1.5),
    },
    colorVariant: {
        color: theme.palette.primary.main,
    },
    boldHeaderText: {
        fontWeight: 700,
        letterSpacing: '0.3px',
    },
}));

const SubtitleText = () => {
    const classes = useStyles();
    return (
        <>
            <Typography className={classes.boldHeaderText} variant="h1">
                Hey,
            </Typography>
            <Typography variant="h1" className={clsx(classes.boldHeaderText, classes.marginTop)}>
                Your&nbsp;
                <Typography component="span" variant="h1" className={clsx(classes.boldHeaderText, classes.colorVariant)}>
                    Account&nbsp;
                </Typography>
                Is
            </Typography>
            <Typography className={clsx(classes.boldHeaderText, classes.marginTop)} variant="h1">
                Ready To Go!
            </Typography>
        </>
    );
};

const SetupAccountStep7Complete = ({ currentPage, onComplete }) => {
    // Don't draw the component if it is not our page.
    if (currentPage !== 6) {
        return null;
    }

    return (
        <div style={{ height: '100vh', backgroundColor: COLOR_WHITE, fontFamily: 'Avenir Next' }}>
            <FullScreenPageNoButton
                Icon={VictoryImage}
                SubtitleText={SubtitleText}
                bodyText={ACCOUNT_SETUP_COMPLETE_MESSAGE_BODY}
                buttonText="Continue"
                onButtonClick={onComplete}
            />
        </div>
    );
};

/* type checking for props */
SetupAccountStep7Complete.propTypes = {
    currentPage: PropTypes.number.isRequired,
    onComplete: PropTypes.func.isRequired,
};

export default SetupAccountStep7Complete;
